// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useSeasonsApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getSeasons = () => request("GET", `${API_STAGES_URL}/v1/seasons`)

  return [
    requestState,
    payload,
    error,
    {
      getSeasons,
    },
  ]
}

export default useSeasonsApi
